import { VxAppColor, vxAppColors } from 'presentation/styleguide/vx-colors-style';

export const vxOscillationColor = (value: number | undefined): VxAppColor => {
  if (value === undefined) {
    return vxAppColors.feedback.genial.default;
  }
  return value < 0 ? vxAppColors.feedback.error.default : vxAppColors.feedback.success.default;
};
